import React, { KeyboardEvent, useContext, useState } from 'react';
import { logEvent } from '../ga/ga-event-logger';
import { searchCepByCity } from './cep-api';
import { CepContext } from './cep-context';

export function SearchBar(){
    const [loading, setLoading] = useState(false);
    const [term, setTerm] = useState("");
    const {dispatch} = useContext(CepContext);

    async function doSearch(){
        if(loading) return
        setLoading(true);

        try{
            const result = await searchCepByCity(term)
            logEvent({type:"cep_search", params: {query: term}})
            dispatch({type:'setSearchTerm', searchTerm: term})
            dispatch({type:'setCities', cities:result})
        }catch(e){
            console.log(e);
        }

        setLoading(false);
    }

    function enter(e:KeyboardEvent){
        if(e.key == 'Enter') 
            doSearch()
    }


    return <div className='d-flex mb-4' style={{maxWidth:"500px"}}>
        <input className='form-control flex-grow' value={term} onChange={(e) => setTerm(e.target.value)} onKeyUp={enter} 
            placeholder="Nome da cidade..." />
        <button className='btn btn-primary ms-2' onClick={() => doSearch()}><i className={`fa ${ !loading ? 'fa-search' : 'fa-spin fa-circle-notch' }`}></i></button>
    </div>
}